import React, {Component} from 'react';
import classnames from 'classnames';
import {ResultRow} from './resultrow';

function isChangedBy(num, threshold) {
    return Math.abs(num) > threshold;
}

export class Results extends Component {
    onClickProxy = (ev) => {
        // If child item, derive id and call onClick callback
        const suggestionKey = ev.target.attributes['data-suggestion-key'];

        if (suggestionKey) {
            const suggestionKeyValue = parseInt(suggestionKey.value, 10);
            const suggestion = this.props.results[suggestionKeyValue];

            if (suggestion) {
                suggestion.suggestionDepth = suggestionKeyValue + 1; // 1-based depth

                this.props.onSelectDestination(suggestion);
                return true;
            }
            this.props.onError(
                'results.js error: unable to resolve destination from results click'
            );
        }
        return false;
    };

    handleTouchStart = (ev) => {
        let {left, top} = ev.target.getBoundingClientRect();
        this.touchLeft = left;
        this.touchTop = top;
        this.touchStartTime = Date.now();
    };

    handleTouchEnd = (ev) => {
        let {left, top} = ev.target.getBoundingClientRect();
        let touchElapseTime = Date.now() - this.touchStartTime;
        let leftChanged = this.touchLeft - left;
        let topChanged = this.touchTop - top;
        if (
            touchElapseTime < 250 &&
            !isChangedBy(leftChanged, 20) &&
            !isChangedBy(topChanged, 20)
        ) {
            this.onClickProxy(ev);
            ev.stopPropagation();
            ev.preventDefault();
            this.props.onBlur();
            return true;
        }
        return false;
    };

    computeSpinnerDom = () => {
        let spinner = null;
        const showSpinner =
            this.props.showSpinner &&
            this.props.xhrPending === true &&
            this.props.results === false;
        if (showSpinner) {
            spinner = (
                <div className="result inactive">
                    <div className="loading-spinner" />
                </div>
            );
        }
        return spinner;
    };

    computeResultsDom = () => {
        const {selectDestinationIndex, results, isTrendingResults} = this.props;

        const hasSelectedIndex = selectDestinationIndex > -1;
        const resultsDOM = results.map((result, index) => (
            <ResultRow
                {...this.props}
                key={`result-row-${result.uuid}`}
                index={index}
                hasSelectedIndex={hasSelectedIndex}
                last={results[index + 1] && !results[index + 1].recentlyviewed}
                result={result}
                selected={selectDestinationIndex === index}
                hasTrendingHeading={
                    isTrendingResults &&
                    !results[index].recentlyviewed &&
                    (!results[index - 1] || results[index - 1].recentlyviewed)
                }
            />
        ));

        return <div>{resultsDOM}</div>;
    };

    render() {
        const {results, useAnim, poweredByGoogle} = this.props;
        let resultsDOM = null;

        let classNames = classnames({
            'search-results-container': true,
            'no-anim': !useAnim,
            'poweredbygoogle-logo': poweredByGoogle
        });

        if (results && results.length > 0) {
            resultsDOM = this.computeResultsDom();
        }

        let spinnerDOM = this.computeSpinnerDom();

        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
                id="Typeahead__results"
                role="listbox"
                tabIndex="-1"
                className={classNames}
                onClick={this.onClickProxy}
                onTouchStart={this.handleTouchStart}
                onTouchEnd={this.handleTouchEnd}
            >
                {resultsDOM}
                {spinnerDOM}
            </div>
        );
    }
}
